export default __webpack_public_path__ + "static/media/ProCal-logo-and-wordmark.dbb95dad.svg";